import { Icon, type IconGlyphProps } from 'BomdisoftComponents/icons/base';
import { INSTAGRAM_GLYPH } from 'BomdisoftComponents/icons/glyphs';

export const InstagramIcon = (props: IconGlyphProps) => <Icon {...props} glyph={INSTAGRAM_GLYPH} />;
